import { Injectable } from "@angular/core";
import { gql, Mutation, Apollo } from "apollo-angular";
import { CreateIdeaCommentInput } from "src/generated/graphql";
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};

export type CreateIdeaCommentMutation = {
  createIdeaComment: { id: string; name: string; message: string };
};
export type CreateIdeaCommentMutationVariables = Exact<{
  data: CreateIdeaCommentInput;
  id: string;
}>;

export const CreateIdeaCommentDocument = gql`
  mutation CreateIdeaComment($data: CreateIdeaCommentInput!, $id: String!) {
    createIdeaComment(data: $data, id: $id) {
      id
      name
      message
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class CreateIdeaCommentGQL extends Mutation<
  CreateIdeaCommentMutation,
  CreateIdeaCommentMutationVariables
> {
  document = CreateIdeaCommentDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
